require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-markt-neuhodis.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-markt-neuhodis");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-markt-neuhodis!./.cache/json/betreuungseinrichtungen-oberwart-markt-neuhodis.json
// module id = 1014
// module chunks = 231608221292675